import { createAction } from 'redux-actions'

const ns = 'progress/'

export const getProgress = createAction(`${ns}GET_PROGRESS`)
export const getProgressSuccess = createAction(`${ns}GET_PROGRESS_SUCCESS`)
export const getProgressFail = createAction(`${ns}GET_PROGRESS_FAIL`)

export const setManualEntryProgressType = createAction(`${ns}SET_MANUAL_ENTRY_PROGRESS_TYPE`)
export const setManualEntryPointsLogicId = createAction(`${ns}SET_MANUAL_ENTRY_POINTS_LOGIC_ID`)
export const setProgressType = createAction(`${ns}SET_PROGRESS_TYPE`)
export const setProgressCustomType = createAction(`${ns}SET_PROGRESS_CUSTOM_TYPE`)
export const setProgressPeriod = createAction(`${ns}SET_PROGRESS_PERIOD`)

export const getCustomProgress = createAction(`${ns}GET_CUSTOM_PROGRESS`)
export const getCustomProgressSuccess = createAction(`${ns}GET_CUSTOM_PROGRESS_SUCCESS`)
export const getCustomProgressFail = createAction(`${ns}GET_CUSTOM_PROGRESS_FAIL`)

export const getCustomProgressForPoints = createAction(`${ns}GET_CUSTOM_PROGRESS_FOR_POINTS`)

export const getDailyProgress = createAction(`${ns}GET_DAILY_PROGRESS`)
export const getDailyProgressSuccess = createAction(`${ns}GET_DAILY_PROGRESS_SUCCESS`)
export const getDailyProgressFail = createAction(`${ns}GET_DAILY_PROGRESS_FAIL`)

export const addCustomEntry = createAction(`${ns}ADD_CUSTOM_ENTRY`)
export const addCustomEntrySuccess = createAction(`${ns}ADD_CUSTOM_ENTRY_SUCCESS`)
export const addCustomEntryFail = createAction(`${ns}ADD_CUSTOM_ENTRY_FAIL`)
export const resetManualEntryInProgress = createAction(`${ns}RESET_MANUAL_ENTRY_IN_PROGRESS`)

export const refreshChallengeResults = createAction(`${ns}REFRESH_CHALLENGE_RESULTS`)

export const getTotalPointsProgress = createAction(`${ns}GET_TOTAL_POINTS_PROGRESS`)
export const getTotalPointsProgressSuccess = createAction(`${ns}GET_TOTAL_POINTS_PROGRESS_SUCCESS`)
export const getTotalPointsProgressFail = createAction(`${ns}GET_TOTAL_POINTS_PROGRESS_FAIL`)

export const setLastBonusPointsAdded = createAction(`${ns}SET_LAST_BONUS_POINTS_ADDED`)
